export default __webpack_public_path__ + "static/Avianis-3c2f19821eee20128514ff2ad041cc7b.svg";